import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { DexFormSectionView } from '@mark43/cad-api';
import { useApplicationType } from '../../common/hooks/use-application-type';

export function useAutoFocusFieldName(sections: DexFormSectionView[]): string | undefined {
    const { isFirstResponder } = useApplicationType();
    const { state } = useLocation();

    return useMemo(() => {
        if (!isFirstResponder || !sections.length) return;

        const section = state?.focusSection
            ? sections.find((section) => section?.title === state?.focusSection)
            : sections?.[0];

        const firstField = section?.rows?.[0]?.[0]?.name;

        if (firstField) {
            return firstField;
        }
    }, [sections, isFirstResponder, state?.focusSection]);
}
